@import "../config/_helpers";
.reviews-section-container {
	background: var(--quarternary-color-light-7);
	padding: 5px 10px 5px 20px !important;
	border-radius: 5px;
	margin-top: auto;
	@include at-breakpoint(0, $m) {
		padding: 5px !important;
	}

	> .row {
		height: 100%;
	}
	img {
		width: 100%;
		max-width: 200px;
		margin: 0 auto;
		margin-bottom: 10px;
	}
	.review-stars {
		// margin-bottom: 10px;
		text-align: center;
		.star {
			color: var(--contrast-color);
		}
	}
	.rating {
		text-align: center;
	}

	.view-more-link {
		margin-top: 5px;
		font-size: 12px;
		display: block;
		text-decoration: underline;
	}

	.reviews-io-section {
		@include at-breakpoint(0, $m) {
			order: 2;
			margin-top: 10px;
			font-size: smaller;
		}
	}
}
